import { Controller, Control, FieldValues, Path, ControllerRenderProps } from 'react-hook-form';
import { Text, withErrorBoundary } from '@oliasoft-open-source/react-ui-library';

interface ControlledTextProps<T extends FieldValues> {
  name: Path<T>;
  control: Control<T>;
  onClick?: (field: ControllerRenderProps<T, Path<T>>) => void;
  text: string;
  disabled?: boolean;
  testId?: string;
}

const RawControlledText = <T extends FieldValues>({
  name,
  control,
  onClick,
  text,
  disabled = false,
  testId,
}: ControlledTextProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <span data-testid={testId}>
          <Text
            link
            onClick={() => {
              if (!disabled && onClick) {
                onClick(field);
              }
            }}
          >
            {text}
          </Text>
        </span>
      )}
    />
  );
};

export const ControlledText = withErrorBoundary(RawControlledText);
